import React from 'react'

import styles from './order-overview-item.css'

const OrderOverviewItem = (props) => {
  const { customClass, children } = props

  return (
    <div className={`${styles.container} ${customClass || ''}`}>
      {children}
    </div>
  )
}

export default OrderOverviewItem
